import { emailRegex, nameRegex } from '~/helpers/helpers';
import { FormInputConfig } from '~/types/residentManagement';

export const formConfig: FormInputConfig[] = [
  {
    label: 'Referral First Name',
    id: 'firstName',
    isRequired: true,
    placeholder: 'Enter first name of person you’re referring',
    pattern: nameRegex(),
    patternErrorMsg: 'Oops! Please enter a valid name',
    styles: {
      inputStyles: { minHeight: '55px' },
      lableStyles: { color: '#344054' }
    }
  },
  {
    label: 'Referral Last Name',
    placeholder: 'Enter last name of person you’re referring',
    id: 'lastName',
    isRequired: true,
    pattern: nameRegex(),
    patternErrorMsg: 'Oops! Please enter a valid name',
    styles: {
      inputStyles: { minHeight: '55px' },
      lableStyles: { color: '#344054' }
    }
  },
  {
    label: 'Referral Email',
    id: 'email',
    isRequired: true,
    placeholder: 'Enter email of person you’re referring',
    pattern: emailRegex(),
    patternErrorMsg: 'Oops! Please enter a valid email',
    styles: {
      inputStyles: { minHeight: '55px' },
      lableStyles: { color: '#344054' }
    }
  },
  {
    label: 'Referral Phone Number',
    id: 'phoneNumber',
    isRequired: true,
    placeholder: 'Enter phone number of person you’re referring',
    styles: {
      inputStyles: { minHeight: '55px' },
      lableStyles: { color: '#344054' }
    }
  }
];

// Shared-link visitors are the referred friend, filling in their own details.
const referredFriendFieldCopy: Record<
  string,
  { label: string; placeholder: string }
> = {
  firstName: { label: 'First Name', placeholder: 'Enter your first name' },
  lastName: { label: 'Last Name', placeholder: 'Enter your last name' },
  email: { label: 'Email', placeholder: 'Enter your email' },
  phoneNumber: {
    label: 'Phone Number',
    placeholder: 'Enter your phone number'
  }
};

export const referredFriendFormConfig: FormInputConfig[] = formConfig.map(
  (field) => ({ ...field, ...referredFriendFieldCopy[field.id] })
);

export enum ReferralIntroMarkups {
  referredBy = '{{referredBy}}',
  buildingName = '{{buildingName}}'
}

export enum ReferralLandingPages {
  V0 = 'original-option',
  V1 = 'diagonal-theme'
}
